import type { ReactNode } from "react";

import { canUsePermission, type PermissionUser } from "./ability";

type PermissionGateProps = {
  user: PermissionUser | null | undefined;
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
};

/** 统一控制页面内操作项是否可见。 */
export function PermissionGate({ user, permission, children, fallback = null }: PermissionGateProps) {
  return canUsePermission(user, permission) ? children : fallback;
}
